import { inject } from '@angular/core';
import { HttpEvent, HttpRequest, HttpHandlerFn, HttpInterceptorFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';
import { AuthService } from '@core/services/auth.service';

export const headerInterceptor: HttpInterceptorFn = (request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const transloco = inject(TranslocoService);

  return next(
    request.clone({
      setHeaders: {
        project: 'upstation',
        Authorization: AuthService.authToken,
        'accept-language': transloco.getActiveLang()
      }
    })
  );
};
